const columns = [
  {
    name: 'Name',
    selector: (row) => row.name,
  },
  {
    name: 'Category',
    selector: (row) => row.category,
  },
  {
    name: 'Type',
    selector: (row) => row.type,
  },
  {
    name: 'Actions',
    selector: (row) => row.actions,
  },
]

export default columns
